export default {
  name: 'Million Acre Challenge',
  domain: 'millionacrechallenge',
  id: '5ed66b0d5e03ea00017ceb91',
  slug: 'million-acre-challenge',
  path: '/million-acre-challenge/',
  logo: '/partners/millionacrechallenge/img/logo.png',
  themes: {
    light: {
      primary: '#6d3a35',
      secondary: '#82AF9C',
      accent: '#FF5722',
      error: '#f44336',
      warning: '#ffc107',
      info: '#82AF9C',
      success: '#8bc34a',
      appbar: '#FFFFFF',
    },
  },
};
